import { z } from "zod";

export const forgotPasswordSchema = z.object({
  email: z
    .string({ required_error: "Email atau username harus diisi" })
    .min(1, "Email atau username harus diisi"),
});

export type ForgotPasswordForm = z.infer<typeof forgotPasswordSchema>;
